import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { Router } from '@angular/router';

import { PlycaDataService } from '../../services/plyca.service';
import { Store } from '@ngrx/store';
import { AppState } from '../store/AppState';
import { TaskDTO } from '../api/plyca-dtos';
import { BaseComponent } from '../components/common/baseComponent/base.component';

@Component({
  selector: 'taskCount',
  templateUrl: 'taskCount.template.html'
})
export class taskCountComponent extends BaseComponent implements OnInit, OnDestroy {
  @Input() estilos: string; //  = 'style1 bg-azul1';
  @Input() descriptionKey; //  = 'Eventos';
  //  @Input() num: number; //  = 4;
  @Input() icon: string; //  = 'fa-clock-o';
  @Input() layoutClass: string;

  // para la navegacion
  @Input() link: string;
  @Input() linkParamName: string; //  = 'TIPO_TAREA';
  @Input() linkParamValue: string; //  = 'TIPO_TAREA';

  // Referencia a la lista de tareas almacenada en el store
  subscription: Subscription;
  numTareas = '-';

  loading = true;
  error = false;
  empty = false;

  reloadSubject: Subject<boolean>;

  constructor(private store: Store<AppState>, private router: Router) {
    super();
  }

  ngOnInit(): void {
    this.subscribe(this.reloadSubject, () => this.reload());

    this.subscription = this.store
      .select('pendingTasks')
      .subscribe((tasks: Array<TaskDTO>) => {
        if (tasks) {
          if (this.linkParamValue) {
            tasks = (<Array<TaskDTO>>tasks).filter(
              (t: TaskDTO) => t.type === this.linkParamValue
            );
          }
          if (tasks && tasks.length) {
            this.numTareas = '' + tasks.length;
          } else {
            this.numTareas = '-';
          }
          this.loading = false;
        }
      });
  }

  reload() {
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    super.ngOnDestroy();
  }

  getNumTareas(): string {
    return this.numTareas;
  }

  widgetClass(): string {
    if (this.numTareas === '-')
      return 'alert-secondary text-secondary';
    else
      return this.estilos;
  }

  navigate() {
    if (this.link) {
      let params = {};
      if (this.linkParamName) {
        if (!this.linkParamValue) {
          this.linkParamValue = '*';
        }
        params[this.linkParamName] = this.linkParamValue;
      }
      this.router.navigate([this.link], { queryParams: params });
    }
  }

  isLoading(): boolean {
    return this.loading;
  }

  isError(): boolean {
    return this.error;
  }

  isOK(): boolean {
    return !this.loading && !this.error && !this.empty;
  }

  isEmpty(): boolean {
    return this.empty;
  }
}
